type PropTypes = {
  className?: string
}

const SubtractIcon = ({ className }: PropTypes) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line
        x1="4"
        y1="7.5"
        x2="12"
        y2="7.5"
        stroke="currentColor"
      />
    </svg>

  )
}

export default SubtractIcon
